import f from "swr";
import { useKnockClient as r } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "react";
import "fast-deep-equal";
import "date-fns";
import { useKnockMsTeamsClient as h } from "../context/KnockMsTeamsProvider.mjs";
const k = "MS_TEAMS_CHANNELS";
function S({
  teamId: e,
  queryOptions: n
}) {
  const s = r(), {
    knockMsTeamsChannelId: a,
    tenantId: l
  } = h(), c = () => s.msTeams.getChannels({
    knockChannelId: a,
    tenant: l,
    teamId: e,
    queryOptions: {
      $filter: n == null ? void 0 : n.filter,
      $select: n == null ? void 0 : n.select
    }
  }), {
    data: t,
    isLoading: o,
    isValidating: m,
    mutate: i
  } = f(e ? [k, e] : null, c, {
    revalidateOnFocus: !1
  });
  return {
    data: (t == null ? void 0 : t.ms_teams_channels) ?? [],
    isLoading: o || m,
    refetch: () => i()
  };
}
export {
  S as default
};
//# sourceMappingURL=useMsTeamsChannels.mjs.map
